module.exports = __webpack_public_path__ + "img/placeholder_header_5.c6df1a6f.jpg";